import { GlassFoldUdBox, GroupSelector, KeyValueLine, KeyValuesHorizontal, RenderLinkToCompanyGraph, RenderLinkToPropertyInfo, ShowSelectedGroup, ViewButtonIcon } from "src/propertyInfoTemplates/PropertyComponents"
import "../css/propertyInfoStyle.css";
import { ApplicationStateContext } from "src/states/ApplicationState";
import { Cookies, Localization } from "@viamap/viamap2-common";
import { PropertyInfoInterface } from "src/managers/PropertyInfoInterface";
import { PropertyInformation } from "src/managers/PropertyInformation";
import { useState, useContext, useEffect, Fragment, useRef } from "react";
import { ProtectedFeature } from "./ProtectedFeature";
import { Feature } from "src/states/ApplicationStateFeatures";
import { MapitStateActionType, MapitStateContext } from "src/states/MapitState";
import { LayerInfo, LayerHierarchy, LayerHierarchyEndNode } from "src/common/managers/Types";
import { OldHierarchy } from "src/managers/OldHierarchy";
import { Persistence } from "src/managers/Persistence";
import { MIBIcon } from "src/componentsUtils/MIBIcon";
import { DC } from "src/dataCollector/DataCollector";
import { WFSCollector } from "src/dataCollector/WFSCollector";
import { groupFeatureById, transformFeatures, unknownToFeatureCollection } from "src/functions/GeojsonHelpers";

type props = {
  personInfo: any,
  foldetUd: boolean,
  cols: number
  callBackOnLoaded?: (a: string) => any
}
export function PersonInfoView(props: props) {

  function setSelectedGroup(string) {
    Cookies.setCookie("PersonInfoSelectedTab", string)
    _setSelectedGroup(string)
  }

  const [selectedGroup, _setSelectedGroup] = useState(
    Cookies.getCookie("PersonInfoSelectedTab") || "Alle"
  );
  const [availableGroup, setAvailableGroup] = useState(["Alle"]);
  const [loading, setLoading] = useState(true)
  const [ejendomsListe, setEjendomsListe] = useState<any[]>([]); // Ejendomme ejet (eller delvist ejet) af Personen.
  const [rolleListe, setRolleListe] = useState<any[]>([]); // Ejendomme ejet (eller delvist ejet) af Personen.

  const { hasAccessToFeature } = useContext(ApplicationStateContext);
  const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);
  const mapitStateRef = useRef(mapitState);
  useEffect(() => { mapitStateRef.current = mapitState; }, [mapitState]);

  useEffect(() => {
    // getDataCache()
    getDataAsync();
  }, [hasAccessToFeature, props.personInfo]);

  async function getDataAsync() {
    if (props.personInfo.cvrPersonId || (props.personInfo.navn && props.personInfo.postnr && props.personInfo.adresse)) {
      function getActiveRecord(recs: { periode: { gyldigFra: string, gyldigTil: string } }[]): any {
        return recs.find((r) => r.periode.gyldigTil === null);
      }
      function aktiveVirksomheder(virksomhedSummariskRelation: any): boolean {
        return virksomhedSummariskRelation?.virksomhed?.livsforloeb && getActiveRecord(virksomhedSummariskRelation.virksomhed.livsforloeb);
      }
      function aktiveFunktioner(organisationer: any): boolean {
        let funktionAttr = organisationer.attributter?.find((org) => org.type === "FUNKTION");
        return funktionAttr?.vaerdier && getActiveRecord(funktionAttr.vaerdier);
      }
      let cvrInfo;
      if (props.personInfo.cvrPersonId) {
        cvrInfo = await PropertyInfoInterface.CVRPersonDeltagerByEnhedsNummer(props.personInfo.cvrPersonId);
      } else {
        if (!(props.personInfo.vejnavn || props.personInfo.husnr)) {
          // split adress into streetname and houseno
          let re = new RegExp(/([^0-9]*)([0-9]+[a-zA-Z]*)/);
          let res = re.exec(props.personInfo.adresse);
          props.personInfo.vejnavn = res && res[1];
          props.personInfo.husnr = res && res[2];
        }
        cvrInfo = await PropertyInfoInterface.CVRPersonDeltagerByNameAndAddress(props.personInfo.navn, props.personInfo.vejnavn, props.personInfo.husnr, props.personInfo.postnr, "DK");
      }

      if ((props.personInfo.navn && props.personInfo.postnr && props.personInfo.adresse) || cvrInfo) {
        let postnr = props.personInfo.postnr || cvrInfo.beliggenhedsadresse[0].postnummer
        let adresse = props.personInfo.adresse || cvrInfo.beliggenhedsadresse[0].vejnavn + " " + cvrInfo.beliggenhedsadresse[0].husnummerFra
        let liste = await PropertyInfoInterface.getPropertiesOwnedByPerson(props.personInfo.navn, postnr, adresse);
        setEjendomsListe(liste?.hits?.hits.map((ht) => {
          let ejd = ht._source;
          let ejerData = PropertyInformation.propertyOwnerMatchingName(ejd.ejf_ejere_liste, props.personInfo.navn);
          ejd._ejerData = ejerData;
          return ejd;
        }) || []);
      } else {
        setEjendomsListe([]);
      }

      let res: any[] = cvrInfo?.virksomhedSummariskRelation?.filter(aktiveVirksomheder).map((vr) => {
        let virkData = {
          cvrNummer: vr.virksomhed.cvrNummer,
          navn: getActiveRecord(vr.virksomhed.navne)?.navn || "ukendt",
        };
        let orgsData = vr.organisationer.filter(aktiveFunktioner).map((org) => {
          return {
            hovedType: org.hovedtype,
            navn: getActiveRecord(org.organisationsNavn)?.navn || "ukendt",
            periode: org.medlemsData[0]?.attributter?.find((a) => a.type == "FUNKTION")?.vaerdier?.[0].periode
          }
        });
        return {
          virkData, orgsData
        }
      }).sort((a, b) => a.virkData.navn > b.virkData.navn ? 1 : -1)
      setRolleListe(res || []);
    } else {
      setRolleListe([]);
    }

    setLoading(false);
    props.callBackOnLoaded?.("Done");

  }

  function PrintHeader() {
    let printDate = new Date().toLocaleDateString();

    return (
      <div className="only-print print-header" style={{}}>
        <div style={{ display: "inline-block" }}>
          <h4>Personinformation</h4>
          <h5>Printed: {printDate}</h5>
        </div>
      </div>
    );
  }
  async function createLayersFromResultsV2(name: string, ejendomsListe: any[]) {
    const bfeNr = ejendomsListe.map((itm) => itm.bfe_sfe_nr);
    let jordstykker = await WFSCollector.Utils.jordstykkerFraSFE(bfeNr);
    jordstykker = transformFeatures(jordstykker, feature => {
      let sfe = feature.properties?.samletFastEjendomLokalId;
      return {
        ...feature,
        properties: {
          ...feature.properties,
          SFEnummer: sfe
        }
      }
    });
    let featureArray = groupFeatureById(jordstykker, "SFEnummer", true);
    let promises = Object.keys(featureArray).map(async (sfeNr) => {
      let features = featureArray[sfeNr];
      let datasetNameToUse = formatOwnerAndPct(ejendomsListe.find((e) => e.bfe_sfe_nr == sfeNr));
      let fc = unknownToFeatureCollection(features);
      if (fc) {
        return new Promise<LayerInfo>((resolve) => {
          Persistence.createLayersFromGeoJSON(datasetNameToUse, fc, new Date(), (li: LayerInfo) => {
            mapitStateDispatch({
              type: MapitStateActionType.AddDataLayer,
              payload: { layerInfo: li, zoomToFocus: false },
              callbacks: {
                onLayerAdded: (createdLi: LayerInfo) => {
                  resolve(createdLi);
                }
              }
            } as any);
          });
        })
      }
    });
    const createdLayerInfos = await Promise.allSettled(promises);
    const createdLayerIds = createdLayerInfos.map(li => li.status == "fulfilled" ? li.value?.layerId : null).filter(id => id !== null) as number[];

    try {
      const latestState = mapitStateRef.current || mapitState;
      const baseHierarchy = latestState?.layerHierarchy || { id: 0, name: "Top Level", isCollapsed: false, children: [] };
      const newHierarchy: LayerHierarchy = JSON.parse(JSON.stringify(baseHierarchy));
      const newGroupId = OldHierarchy.extractLowestId(baseHierarchy) - 1;
      const groupNameToUse = name ? name : Localization.getText("Group");
      const newGroup: LayerHierarchy = { id: newGroupId, name: groupNameToUse, isCollapsed: false, children: [] };
      newHierarchy.children = [newGroup, ...(newHierarchy.children || [])];
      createdLayerIds.forEach((layerId) => {
        OldHierarchy.removeLayerInHierarchy(layerId, newHierarchy);
        newGroup.children.push({ id: layerId } as LayerHierarchyEndNode);
      });
      mapitStateDispatch({ type: MapitStateActionType.SetLayerHierarchy, payload: { hierarchy: newHierarchy } });
    } catch (e) {
      console.error("Failed to create group for new layers", e);
    }
  }

  async function createLayersFromResults(name: string, ejendomsListe: any[]) {
    const toCreate = ejendomsListe;

    async function getGeometriesForItems(items: any[]): Promise<any[]> {
      const bfeNr = items.map((itm) => itm.bfe_sfe_nr);
      let featureCollection = await DC.WFS.getFeatureQuery("Matriklen2", "SamletFastEjendom_Gaeldende",
        `BFEnummer in (${bfeNr.map((a) => `'${a}'`).join(",")})`
      );
      return featureCollection.features;
    }

    const geometries = await getGeometriesForItems(toCreate);

    function convertToGeojsonGeometry(items: any[]): any {
      return {
        type: "FeatureCollection",
        features: items.map((itm) => ({
          type: "Feature",
          geometry: geometries.find((f: any) => f.properties.BFEnummer == itm.bfe_sfe_nr)?.geometry || null,
          properties: {
            SFEnummer: itm.bfe_sfe_nr,
          }
        }))
      }
    }

    let createPromises: Promise<LayerInfo>[] = [];
    try {
      createPromises = toCreate.map((c: any) => new Promise<LayerInfo>((resolve, reject) => {
        const datasetNameToUse = formatOwnerAndPct(c);
        let fc = convertToGeojsonGeometry([c]);
        if (!fc.features[0].geometry) {
          reject(new Error("No geometry found for item with BFEnummer " + c.bfe_sfe_nr));
          return;
        }
        Persistence.createLayersFromGeoJSON(datasetNameToUse, fc, new Date(), (li: LayerInfo) => {
          try {
            // Dispatch AddDataLayer with a callback so the reducer returns the authoritative LayerInfo
            // (with assigned layerId). Resolve the promise when onLayerAdded is invoked.
            mapitStateDispatch({
              type: MapitStateActionType.AddDataLayer,
              payload: { layerInfo: li, zoomToFocus: false },
              callbacks: {
                onLayerAdded: (createdLi: LayerInfo) => {
                  try {
                    resolve(createdLi);
                  } catch (err) {
                    reject(err);
                  }
                }
              }
            } as any);
          } catch (err) {
            reject(err);
          }
        });
      }));
    } catch (e) {
      console.error("Error creating layers from results", e);
      return;
    }

    const createdLayerInfos = await Promise.allSettled(createPromises);
    const createdLayerIds = createdLayerInfos.map(li => li.status == "fulfilled" ? li.value.layerId : null).filter(id => id !== null) as number[];

    try {
      const latestState = mapitStateRef.current || mapitState;
      const baseHierarchy = latestState?.layerHierarchy || { id: 0, name: "Top Level", isCollapsed: false, children: [] };
      const newHierarchy: LayerHierarchy = JSON.parse(JSON.stringify(baseHierarchy));
      const newGroupId = OldHierarchy.extractLowestId(baseHierarchy) - 1;
      const groupNameToUse = name ? name : Localization.getText("Group");
      const newGroup: LayerHierarchy = { id: newGroupId, name: groupNameToUse, isCollapsed: false, children: [] };
      newHierarchy.children = [newGroup, ...(newHierarchy.children || [])];
      createdLayerIds.forEach((layerId) => {
        OldHierarchy.removeLayerInHierarchy(layerId, newHierarchy);
        newGroup.children.push({ id: layerId } as LayerHierarchyEndNode);
      });
      mapitStateDispatch({ type: MapitStateActionType.SetLayerHierarchy, payload: { hierarchy: newHierarchy } });
    } catch (e) {
      console.error("Failed to create group for new layers", e);
    }
  }

  let x = ejendomsListe[0]?.ejf_ejere_liste && PropertyInformation.propertyOwnerMatchingName(ejendomsListe[0]?.ejf_ejere_liste, props.personInfo.navn) || undefined

  let fødselsdato = props.personInfo.foedselsdato || x?.foedselsdato
  let dateString = fødselsdato ? (new Date(fødselsdato)).toLocaleDateString() || x.foedselsdato : "no date";
  let age = fødselsdato ? calculateAge(new Date(fødselsdato)) : undefined;
  function calculateAge(dob: Date) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);

    return Math.abs(age_dt.getUTCFullYear() - 1970);
  }


  const [isAddingSFE, setIsAddingSFE] = useState(false);
  return (
    <>
      <PrintHeader />
      <KeyValuesHorizontal>
        <KeyValueLine valKey={"Navn"} value={props.personInfo.navn} />
        <KeyValueLine valKey={"Fødselsdato"} value={fødselsdato && dateString} />
      </KeyValuesHorizontal>

      <GroupSelector
        selected={selectedGroup}
        group={availableGroup}
        onSelect={setSelectedGroup}
      />
      <div className="Scroll-content">
        <ShowSelectedGroup
          keepSelected={true}
          loading={loading}
          columns={props.cols!}
          group={selectedGroup}
          groupCallBack={(groups) =>
            setAvailableGroup([...new Set([...groups, "Alle"])])
          }
        >
          <GlassFoldUdBox group="Person" foldetUd={props.foldetUd} title={"Person Oplysninger"} >
            <KeyValueLine valKey={"Navn"} value={props.personInfo.navn} />
            <KeyValueLine valKey={"Fødselsdato"} value={dateString} />
            <KeyValueLine valKey={"Alder"} value={age} />
          </GlassFoldUdBox>
          <GlassFoldUdBox group="Ejendomme" foldetUd={props.foldetUd} title={(
            <>
              {`Ejendomme ${ejendomsListe && ejendomsListe.length > 0 ? `(${ejendomsListe?.length})` : ""}`}
              {ejendomsListe?.length > 0 ? (
                <div style={{ display: "flex", gap: "5px", flexWrap: "wrap", justifyContent: "flex-end", flex: "auto" }} >
                  <ProtectedFeature feature={Feature.ExplorerSaveAsNewLayer} contentsIfNoAccess={<></>} >
                    <ViewButtonIcon
                      disabled={isAddingSFE}
                      style={{ marginBottom: "5px", backgroundColor: isAddingSFE ? "lightgrey" : undefined }}
                      onClick={async (e) => {
                        e.stopPropagation();
                        setIsAddingSFE(true);
                        try {
                          let name = "Ejendomme (SFE) ejet af " + props.personInfo.navn; // + (fødselsdato ? ", født " + dateString : "");
                          await createLayersFromResultsV2(name, ejendomsListe);
                        } finally {
                          setIsAddingSFE(false);
                        }
                      }}
                      title={Localization.getText("Add as SFE layer")}
                    ><MIBIcon icon="addToMapSFE" /></ViewButtonIcon>
                  </ProtectedFeature>
                </div>
              ) : null}
            </>
          )}>
            {
              ejendomsListe?.map((ejd, idx) => {
                let text = formatOwnerAndPct(ejd);
                return (
                  <Fragment key={idx}>
                    BFEnr: {ejd.bfe_nr}
                    {RenderLinkToPropertyInfo(text, { bfeNr: ejd.bfe_nr })}<br />
                  </Fragment>
                );
              })
            }

          </GlassFoldUdBox>
          <GlassFoldUdBox group="Roller" foldetUd={props.foldetUd} title={"Roller"} >
            {
              rolleListe?.map((rel, idx) => {

                let text = (<>{rel.virkData.navn} (<RenderLinkToCompanyGraph cvrNr={rel.virkData.cvrNummer} />)</>);
                let rolleListe = rel.orgsData.map((org) => {
                  if (org.periode?.gyldigTil || !(org.periode?.gyldigFra)) {
                    return ""
                  }
                  return org.navn + " (" + org.periode?.gyldigFra.split("-").reverse().join(".") + "- ... )"; //  + "("+org.hovedType+")";
                }, "").filter((a) => a).join("\n")
                return (
                  <Fragment key={idx} >
                    <KeyValueLine valKey={text} value={rolleListe} />
                  </Fragment>
                );
              })
            }
          </GlassFoldUdBox>
          <GlassFoldUdBox group="Roller" foldetUd={props.foldetUd} title={"Ophørte Roller"} >
            {
              rolleListe?.map((rel, idx) => {

                let text = (<>{rel.virkData.navn} (<RenderLinkToCompanyGraph cvrNr={rel.virkData.cvrNummer} />)</>);
                let rolleListe = rel.orgsData.map((org) => {
                  if (!(org.periode?.gyldigTil)) {
                    return ""
                  }
                  return org.navn + " (" + org.periode?.gyldigFra.split("-").reverse().join(".") + "-" + org.periode?.gyldigTil.split("-").reverse().join(".") + ")"; //  + "("+org.hovedType+")";
                }, "").filter((a) => a).join("\n")
                return (
                  <Fragment key={idx}>
                    <KeyValueLine valKey={text} value={rolleListe} />
                  </Fragment>
                );
              })
            }
          </GlassFoldUdBox>

        </ShowSelectedGroup>
      </div>

    </>
  )

  function formatOwnerAndPct(ejd: any) {
    let text = ejd.bfe_adresse;
    let ejerData = ejd._ejerData;
    if (ejerData && ejerData.andelProcent /* && ejerData.andelProcent < 100 */) {
      text += " (" + ejerData.andelProcent + "%)";
    }
    return text;
  }
}